"use client";

import type {
  ListLotsQuery,
  LocationResponse,
  PaginationQuery,
  StockLotResponse,
  VendorResponse,
} from "@stocks/shared";

import { usePaginatedList } from "@/shared/libs/query";

export const stockKeys = {
  stocks: "stocks",
  vendors: "stock-vendors",
  locations: "stock-locations",
  lots: "stock-lots",
} as const;

const OPTION_QUERY: PaginationQuery = { pageSize: 100, sort: "name", order: "asc" };

/** 입고 시 선택용 공급업체 목록 */
export const useVendorOptions = () =>
  usePaginatedList<VendorResponse>(
    stockKeys.vendors,
    "/v1/stocks/vendors",
    OPTION_QUERY,
  );

/** 입고 시 선택용 보관 위치 목록 */
export const useLocationOptions = () =>
  usePaginatedList<LocationResponse>(
    stockKeys.locations,
    "/v1/stocks/locations",
    OPTION_QUERY,
  );

/** 품목의 기존 로트 목록 (입고 시 기존 로트에 합산하는 경우) */
export const useLotOptions = (itemId: string | undefined) =>
  usePaginatedList<StockLotResponse, ListLotsQuery>(
    stockKeys.lots,
    "/v1/stocks/lots",
    { itemId: itemId ?? "", pageSize: 100 },
    { enabled: !!itemId },
  );
